import api from "../store/services/api";

export const getDeliveryOperators = (params) =>
  api.get("/user/operators/", { params });

export const createDeliveryOperator = (operator) =>
  api.post("/register/agent/", operator, {
    headers: { "Content-Type": "application/json" },
  });

export const editDeliveryOperator = (operatorId, operatorObj) =>
  api.put(`/register/agent/?id=${operatorId}`, operatorObj, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteDeliveryOperator = (operatorId) =>
  api.delete(`/register/agent/?id=${operatorId}`);

const DeliveryOperatorService = {
  createDeliveryOperator,
  editDeliveryOperator,
  deleteDeliveryOperator,
};

export default DeliveryOperatorService;
